import axios from 'axios';
import { Link } from 'react-router-dom';
import Loader from 'react-loader-spinner';
import React, { useEffect, useContext, useCallback } from 'react';

import Pagination from '../Pagination';
import BlogSidebar from '../BlogSidebar';
import { formatDate } from '../../utils/moment.util';
import { AppStateContext, AppDispatchContext } from '../../contexts/AppContext';

import './style.css';

const baseUrl = process.env.REACT_APP_BASE_URL;

const BlogList = () => {
  const { state } = useContext(AppStateContext);
  const { dispatch } = useContext(AppDispatchContext);

  const fetchPosts = useCallback(
    (page) => {
      dispatch({
        type: 'SET-LOADING-POSTS',
        payload: true,
      });

      axios
        .get(`${baseUrl}/blog?page=${page}`)
        .then((res) => {
          const {
            totalPages,
            page,
            hasPrevPage,
            hasNextPage,
            nextPage,
            prevPage,
          } = res.data.data;

          dispatch({
            type: 'SET-PAGINATION',
            payload: {
              totalPages,
              hasPrevPage,
              hasNextPage,
              nextPage,
              prevPage,
              currentPage: page,
            },
          });

          dispatch({
            type: 'SET-POSTS',
            payload: res.data.data.docs || [],
            postsFetched: true,
          });

          dispatch({
            type: 'SET-LOADING-POSTS',
            payload: false,
          });
        })
        .catch((err) => {
          dispatch({
            type: 'SET-LOADING-POSTS',
            payload: false,
          });

          dispatch({
            type: 'SET-LOADING-POSTS-ERROR',
            payload: true,
          });
        });
    },
    [dispatch]
  );

  useEffect(() => {
    fetchPosts(1);
  }, [fetchPosts]);

  return (
    <section className="wpo-blog-pg-section section-padding">
      <div className="container">
        {state.loadingPosts ? (
          <div className="loader-container">
            <Loader type="Oval" color="#d90404" height={80} width={80} />
          </div>
        ) : state.loadingPostsError ? (
          <div className="text-center">
            <p>Could not fetch blog posts. Refresh or check back later.</p>
          </div>
        ) : !state.posts.length ? (
          <div className="text-center">
            <p>No blog posts. Check back later.</p>
          </div>
        ) : (
          <div className="row">
            <div className="col col-lg-8 col-12">
              <div className="wpo-wpo-blog-content">
                {state.posts.map((post) => (
                  <div className="post format-standard-image" key={post._id}>
                    <div className="entry-media">
                      <img src={post.image} alt="" />
                    </div>
                    <ul className="entry-meta">
                      <li>
                        <Link to={`/blog-details/${post.slug}`}>
                          <img src={post.createdBy.image} alt="" /> By{' '}
                          {post.createdBy.username}
                        </Link>
                      </li>
                      <li>
                        <i className="ti-calendar"></i>{' '}
                        {formatDate(post.createdAt, 'MMM DD, YYYY')}
                      </li>
                    </ul>
                    <h3>
                      <Link to={`/blog-details/${post.slug}`}>
                        {post.title}
                      </Link>
                    </h3>
                    <p>{post.excerpt}...</p>
                    <Link
                      to={`/blog-details/${post.slug}`}
                      className="read-more"
                    >
                      Read More...
                    </Link>
                  </div>
                ))}
                {state.postsPagination.totalPages > 1 && (
                  <Pagination
                    paginationDetails={state.postsPagination}
                    fetchMore={fetchPosts}
                  />
                )}
              </div>
            </div>
            <BlogSidebar />
          </div>
        )}
      </div>
    </section>
  );
};

export default BlogList;
